import {
  Card,
  CardContent,
  TableContainer,
  Table,
  TableHead,
  Box,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";

import { DataTableBody } from "@/components/DataTableBody";
import { QueryTextField } from "@/components/QueryTextField";
import { ItemsTotal } from "@/components/ItemsTotal";
import { getProductMemberships } from "@/services/product";
import { SearchParamsPagination } from "@/components/SearchParamsPagination";

import {
  MembershipTableHead,
  ProductMembershipTableRow,
} from "./MembershipTableRow";

const QUERY_KEY = "product-memberships";

export function ProductMembershipList() {
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();

  const { data: raw, isFetching } = useQuery([QUERY_KEY, query], () =>
    getProductMemberships(query)
  );

  const data = raw?.data ?? [];
  const total = raw?.total;

  return (
    <>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box mb={2}>
            <QueryTextField sx={{ width: 560 }} placeholder="ค้นหาชื่อ" />
          </Box>
          <ItemsTotal count={total} />
          <TableContainer sx={{ height: "600px", overflowX: "hidden" }}>
            <Table stickyHeader>
              <TableHead>
                <MembershipTableHead />
              </TableHead>
              <DataTableBody loading={isFetching} data={data}>
                {data.map((item) => (
                  <ProductMembershipTableRow key={item.id} data={item} />
                ))}
              </DataTableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
      <SearchParamsPagination total={total} />
    </>
  );
}
